/**
 * Plan API — STOPGAP local shim. Returns the dummy catalog and fakes the
 * "switch plan" call. Keeps the async + { ok, data } shape the rest of the
 * app's api/* modules use, so the components don't care that it's local yet.
 *
 * TODO(bff): when the plan endpoints ship (later today), replace the bodies
 * with real calls — likely getPlanService().fetchPlans() /
 * getPlanService().updateTenantPlan(planId) through the framework client —
 * and keep these signatures/return shapes identical.
 */
import { PLANS, getPlan } from "../plans/data/plans";
import Logger from "../common/utils/Logger";

export const fetchPlans = async () => {
  Logger("Plans · fetchPlans (local stub)", PLANS.length);
  return { ok: true, data: PLANS };
};

export const updateTenantPlan = async (planId) => {
  const plan = getPlan(planId);
  Logger("Plans · updateTenantPlan (local stub)", planId);
  if (!plan || plan.id !== planId) {
    return { ok: false, error: "Unknown plan." };
  }
  // No backend yet — the caller persists the choice on the user object via
  // UserContext so the sidebar + this page reflect it immediately.
  return { ok: true, data: { planId: plan.id } };
};
